import { SEOTemplate } from '@ui/components/SEO';
import { UseYourTokenDrawer } from '@ui/components/useYourTokenDrawer';
import type { NextPage } from 'next';

import { VnoAndGarden } from './VnoAndGarden';

export const VnoView: NextPage = () => {
  return (
    <>
      <SEOTemplate
        title="Lock VNO & earn rewards in the Fountain & Reservoir - Veno Finance"
        description="Lock your VNO to earn real yield with the Reservoir. Earn more VNO with the Fountain."
      />
      <VnoAndGarden />
      <UseYourTokenDrawer />
    </>
  );
};
